export default {
  "meta-title": "TARISLAND",
  "meta-description": "Tarisland is a classic MMORPG on PC and mobile devices, featuring raids, diverse classes, crossplay and a vast world for exploration. Embark on your epic adventure together.",
  "meta-keywords": "tarisland,taris,comme wow,mmo,mmorpg,multiplateforme,mmomobile,mmoPC",
  "meta-name": "Tarisland Official Website",
  "meta-image": "${HOST_NAME}/assets/images/share.jpg",
  "meta-og-site_name": "Tarisland Official Website",
  "meta-og-title": "Tarisland Official Website",
  "meta-og-description": "You will experience a classic cross-platform MMORPG and team up with your closet friends to enjoy the hardcore raids.",
  "meta-og-url": "${HOST_NAME}/${LANG}/home.html",
  "meta-og-url2": "${HOST_NAME}/${LANG}/index.html",
  "meta-og-image": "${HOST_NAME}/assets/images/share.jpg",
  "meta-twitter-site": "${HOST_NAME}",
  "meta-twitter-title": "Tarisland Official Website",
  "meta-twitter-description": "You will experience a classic cross-platform MMORPG and team up with your closet friends to enjoy the hardcore raids.",
  "meta-twitter-url": "${HOST_NAME}/${LANG}/home.html",
  "meta-twitter-url2": "${HOST_NAME}/${LANG}/index.html",
  "meta-twitter-image": "${HOST_NAME}/assets/images/share.jpg",

  "email_illegal": "Incorrect Email address. Please check and resubmit it.",
  "horizon_tip": "For a better experience, please rotate your device.",




  'downloadPc': "Please download on PC",

  "area": "Area",
  "select-area": "Please select area",
  "server": "Server",
  "select-server": "Please select server",
  "character-name": "Character Name",
  "select-character": "Please select character",
  "please-select": "Please select",
  "not-found-role": "Character information not found",
  'loading': 'loading....',
  'pls_input_info': 'Please enter your login information.',
  "pls_input_email": "Please enter an email address",
  'FlowHasNotBegin': 'The event has not started yet',
  'FlowHasEnd': 'The event has ended',

  // 复制到剪贴板内容 需要拼接
  "copy_clipboard-text1": "Become my Tarisland partner now!\nClick/Tap:",
  "copy_clipboard-text2": "(exclusive link)\nIf the link fails, you can enter the invitation code: ",

  "friends-completed": "friends completed",
  "no-friends-completed": "No friends have completed yet",
  "pop_invitedlist_s": "COMPLETED ",
  "pop_invitedlist_f": "INCOMPELTED",
  "gift3": "Season 1 Growth Pack",
  "gift5": "Spirit of Frostwolf (Permanent)",
  "gift6": "Spirit of Frostwolf (1-Day Trial Card)",
  "gift1": "$100 gift card",
  "gift2": "$50 gift card",
  "gift4": "Spirit of Pyro Tiger (Permanent)",

  "invite_link_upper_limit": "Sorry, this invitation link or code has reached its maximum number of uses.",
  "invite_link_disabled": "Invalid invitation link or expired code. Please check with the inviter.",
  "enter_your_invitation_code": "Enter your invitation code",
  "act_not_start": "The event has not started.",
  "act_finished": "The event has ended.",
  "download_pc": "Please download on PC",
  "email_error": "Invalid email. Please check.",
  "loadding": "Loading...",
  "check_my_raffle_history": "View my raffle history",
  "no_raffle_history": "No raffle history",
  "system-error": "System Error",
  "cant-invite-self": "You can’t invite yourself",
}